import {
  APP_BASE_HREF,
  LocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withXsrfConfiguration,
} from '@angular/common/http';
import {
  ErrorHandler,
  NgModule,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutAlertFlashModule } from '@callrail/looky/common/layout/shared';
import {
  apiInterceptorFn,
  SignalContextVerticalConfigResolver,
} from '@callrail/looky/common/core/api';
import { VerticalConfigResolver } from '@callrail/looky/vertical-label';
import { environment } from '../environments/environment';
import { AnubisInitService } from './services/anubis-init/anubis-init.service';
import {
  AnubisLoginModule,
  ErrorCatcher,
  StytchPublicToken,
} from '@callrail/looky/anubis/login/shared';
import { Content } from '@builder.io/sdk-angular';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import {
  CognitoUserPool,
  CognitoUserPoolConfigService,
} from '@callrail/looky/common/core/shared';

const init = (anubisInit: AnubisInitService) => () => anubisInit.init();

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    AnubisLoginModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    Content,
    AmplifyAuthenticatorModule,
    LayoutAlertFlashModule,
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: APP_BASE_HREF, useValue: '/authenticate/' },
    provideAppInitializer(() => {
      const initializerFn = init(inject(AnubisInitService));
      return initializerFn();
    }),
    {
      provide: CognitoUserPoolConfigService,
      useFactory: () => {
        const service = new CognitoUserPoolConfigService();
        const defaultConfig = JSON.stringify(service.defaultProdConfig);
        const config = JSON.parse(
          sessionStorage.getItem(`userPoolConfig:${location.hostname}`) ||
            defaultConfig
        ) as CognitoUserPool;
        service.setUserPoolIds(config);
        return service;
      },
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: ErrorHandler, useClass: ErrorCatcher },
    { provide: 'env', useValue: environment },
    {
      provide: VerticalConfigResolver,
      useExisting: SignalContextVerticalConfigResolver,
    },
    {
      provide: StytchPublicToken,
      useFactory: () =>
        sessionStorage.getItem(`stytchPublicToken:${location.hostname}`) || '',
    },
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([apiInterceptorFn(environment.development)]),
      withXsrfConfiguration({
        cookieName: 'CSRF-TOKEN',
        headerName: 'X-CSRF-Token',
      })
    ),
  ],
})
export class AppModule {}
